module.exports = __webpack_public_path__ + "img/buzhou.ab0d1f56.jpeg";